
import { defineComponent, reactive, ref, getCurrentInstance } from 'vue';
import { useRouter } from 'vue-router';
import { Regist } from '@/types/Regist';
import { business_options } from '@/business.ts';
import { app } from '../main';

export default defineComponent({
  setup() {
    const router = useRouter()
    const internalInstance = getCurrentInstance()
    const refFrmRegist: any = ref(null)
    const message = ref('')
    const frmRegist: Regist = reactive({
        corporate_name: '',
        postal_code: '',
        address: '',
        tel: '',
        business: '',
        person_charge: '',
        mail_address: '',
        password: '',
        checkPass: '',
        agree: false,
    })
    const checkAgree = (rule: any, value: string, callback: any) => {
        if(!value) {
            return callback(new Error('個人情報の取扱いについて確認してください。'));
        }else {
            callback();
        }
    }
    const validatePass2 = (rule: any, value: string, callback: any) => {
        if(value === '') {
          callback(new Error('確認用パスワードを入力してください。'));
        }else if(value !== frmRegist.password) {
          callback(new Error('2回入力されたパスワードが一致しません。'));
        }else {
          callback();
        }
    }
    const rules = {
        postal_code: [
        { required: true, message: '郵便番号を入力してください。', trigger: 'blur' },
        { min: 8, message: '文字数が不足しています（123-4567）。', trigger: 'blur' }
        ],
        address: [
        { required: true, message: '住所を入力してください。', trigger: 'blur' },
        ],
        tel: [
        { required: true, message: '電話番号を入力してください。', trigger: 'blur' },
        { min: 8, message: 'Length should be 8', trigger: 'blur' }
        ],
        business: [
        { required: true, message: '業種を選択してください。', trigger: 'change' }
        ],
        person_charge: [
        { required: true, message: 'ご担当者名を入力してください。', trigger: 'blur' },
        ],
        mail_address: [
        { required: true, message: 'メールアドレスを入力してください。', trigger: 'blur' },
        ],
        password: [
        { required: true, message: 'パスワードを入力してください。', trigger: 'blur' },
        { min: 8, message: '8文字以上必要です。', trigger: 'blur' }
        ],
        checkPass: [
        { validator: validatePass2, trigger: 'blur' }
        ],
        agree: [
        { validator: checkAgree, trigger: 'blur' },
        ],
    }
    const resetForm = () => {
        refFrmRegist.value.resetFields()
    }
    const submitForm = () => {
        const api_path = internalInstance?.appContext.config.globalProperties.api_path
        refFrmRegist.value.validate((valid: boolean) => {
            if(valid) {
                fetch(api_path + 'ajax/regist_user.php', {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(frmRegist)
                })
                .then(response => response.json())
                .then(json => {
                    //console.log(json);
                    if(json['result'] == 'failure') {
                        throw new Error(json.error)
                    }
                    message.value = ""
                    app.config.globalProperties.$alert(
                        '登録したメールアドレスに確認メールを送信しました。リンクをクリックして確認処理を完了させてください。',
                        '会員登録',
                        {
                            confirmButtonText: 'OK',
                            callback: null
                        }
                    );
                    refFrmRegist.value.resetFields();
                    router.push({ path: '/login' });
                })
                .catch(error => {
                    console.error(error)
                    message.value = error.message
                })
            }else {
                console.log('invalid')
            }
        })
    }
    return {
        refFrmRegist,
        frmRegist,
        rules,
        message,
        business_options,
        resetForm,
        submitForm
    }
  }
})
